module.exports = __webpack_public_path__ + "img/locked expiring 5 days.567b7470.svg";